import React from 'react';
import { PreviewComponent } from './PreviewFruit';

const PreviewProduct = props => (
    <div className="PreviewFruit">
        <div className={'CenterFruit o' + props.orientation}>
            <div className="PreviewFruitContainer">
                <PreviewComponent rayon="product" {...props} />
            </div>
        </div>
    </div>
);

export default PreviewProduct;
